import DeleteIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Stack, Tooltip } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface RowActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  /** Extra buttons rendered before edit and delete. */
  children?: ReactNode;
}

export function RowActions({ onEdit, onDelete, children }: RowActionsProps) {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={0.5} justifyContent="flex-end">
      {children}
      {onEdit && (
        <Tooltip title={t('common.edit')}>
          <IconButton size="small" onClick={onEdit} aria-label={t('common.edit')}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {onDelete && (
        <Tooltip title={t('common.delete')}>
          <IconButton size="small" onClick={onDelete} aria-label={t('common.delete')} color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
